import React, { useEffect, useState } from "react";
import "../styles/SubscriptionManagementPage.css";
import MyPageSidebar from "./MyPageSidebar";
import { useNavigate } from "react-router-dom";
import MyPageEmpty from "./MyPageEmpty";

const SubscriptionManagementPage = () => {
    var navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showExpired, setShowExpired] = useState(true);
    const [visibleCount, setVisibleCount] = useState(6);

    // 🔥 실제 연동 데이터 (API 연동 가능)
    useEffect(() => {
        const fetchSubscriptionData = async () => {
            try {
                const response = await fetch("/api/subscription-list",

                    ); // ✅ 실제 API 호출
                if (response.ok) {
                    const data = await response.json();
                    setSubscriptions(data.subscriptionData || []);
                }
            } catch (error) {
                console.error("데이터를 불러오는 중 오류 발생:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchSubscriptionData();
    }, []);

    if (isLoading) return <p>로딩중...</p>;

    if (subscriptions === "noData" && !isLoading) {
        return (
            <div className="mypage-layout">
                <MyPageSidebar />
                <div className="subscription-container">
                    <h2 className="mypage-title">결제 상품 관리</h2>
                    <MyPageEmpty />
                </div>
            </div>
        );
    }

    // 🔍 검색 기능 (상품명 검색)
    const filteredSubscriptions = subscriptions.filter(sub =>
        sub.itemName.includes(searchTerm)
    );

    // ✅ 만료 상품 숨기기 기능
    const visibleSubscriptions = showExpired
        ? filteredSubscriptions
        : filteredSubscriptions.filter(sub => sub.allExpired === false);

    return (
        <div className="mypage-layout">
            <MyPageSidebar />
            <div className="subscription-container">
                <h2 className="mypage-title">결제 상품 관리</h2>

                {/* 검색 & 필터 */}
                <div className="subscription-header">
                    <label className="subscription-checkbox">
                        <input
                            type="checkbox"
                            checked={!showExpired}
                            onChange={() => setShowExpired(!showExpired)}
                        />
                        <span>기간 만료된 상품 숨기기</span>
                    </label>
                    <div className="subscription-search">
                        <input
                            type="text"
                            placeholder="검색"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button>
                            <img src="/images/icon/search_icon.png" alt="검색 아이콘" />
                        </button>
                    </div>
                </div>

                {/* 구독 리스트 */}
                <div className="subscription-list">
                    {visibleSubscriptions.slice(0, visibleCount).map((sub) => (
                        <div key={sub.itemId} className="subscription-card">
                            {/* ✅ 썸네일이 없을 경우 기본 이미지 표시 */}
                            <img
                                src={sub.itemThumbnail || "/images/icon/no_product.png"}
                                alt="상품 이미지"
                                className="subscription-image"
                            />
                            <div className="subscription-info">
                                <h3>{sub.itemName}</h3>
                                <p>{sub.count}개</p>
                                <p className="subscription-status">
                                    활성<span className="active">{sub.grantedCount}개</span>
                                    비활성<span className="inactive"> {sub.beforeUseCount}개</span>
                                    만료<span className="expired"> {sub.expiredCount}개</span>
                                </p>
                            </div>
                            <button
                                className="subscription-detail-btn"
                                onClick={() => navigate(`/mypage/subscription/detail/${sub.itemId}`)}
                            >
                                상세보기 &gt;
                            </button>
                        </div>
                    ))}
                </div>

                {/* ✅ 더보기 버튼 */}
                {visibleCount < visibleSubscriptions.length && (
                    <button className="load-more-btn" onClick={() => setVisibleCount(visibleCount + 5)}>
                        더보기 &or;
                    </button>
                )}
            </div>
        </div>
    );
};

export default SubscriptionManagementPage;
